import React from "react";

import styles from "./newSessionDialog.module.css";

export function NewSessionDialog({ open, busy, onCancel, onConfirm }) {
  React.useEffect(() => {
    if (!open) return undefined;
    const onKeyDown = (event) => {
      if (event.key === "Escape" && !busy) onCancel();
    };
    document.addEventListener("keydown", onKeyDown);
    return () => document.removeEventListener("keydown", onKeyDown);
  }, [busy, onCancel, open]);

  if (!open) return null;
  return (
    <div
      className={styles.newSessionDialogMask}
      onMouseDown={(event) => {
        if (event.target === event.currentTarget && !busy) onCancel();
      }}
    >
      <section
        className={styles.newSessionDialog}
        role="alertdialog"
        aria-modal="true"
        aria-labelledby="new-session-dialog-title"
        aria-describedby="new-session-dialog-description"
      >
        <div className={styles.newSessionIcon} aria-hidden="true">↻</div>
        <div className={styles.newSessionContent}>
          <h2 id="new-session-dialog-title">开始新的核算？</h2>
          <p id="new-session-dialog-description">
            新建后，将进入一个空白会话，当前会话仍会保留。
          </p>
          <p className={styles.newSessionNote}>
            之后可以通过“会话管理”重新打开并继续核算。
          </p>
        </div>
        <div className={styles.newSessionActions}>
          <button type="button" className={styles.newSessionCancelButton} onClick={onCancel} disabled={busy} autoFocus>
            继续当前会话
          </button>
          <button type="button" className={styles.newSessionConfirmButton} onClick={onConfirm} disabled={busy}>
            {busy ? "正在新建…" : "新建会话"}
          </button>
        </div>
      </section>
    </div>
  );
}
